import { render, staticRenderFns } from "./MatterLegalEvidenceSamplesForm.vue?vue&type=template&id=12f36094&"
import script from "./MatterLegalEvidenceSamplesForm.vue?vue&type=script&lang=js&"
export * from "./MatterLegalEvidenceSamplesForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterLegalEvidenceSamplesForm.vue?vue&type=style&index=0&id=12f36094&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports